<template>
  <div id="heroSec">
    <div class="logoWrapper">
      <img src="/img/mvp-logo.png" class="logo" alt="MVP logo" />
    </div>
    <div class="heroWrapper"> 
        <h1 class="heroDate">NOW SELLING</h1>
        <h1 class="heroRelease">LIMITED RELEASE
            <br/>
            FREEHOLD TOWNS
        </h1>
        <div class="heroBox"> 
            <span class="heroText">FROM</span>
            <h1 class="heroPrice">$560,973*</h1>            
        </div>
        <h4 style="font-size: 14px;">*PRICE NET OF HST</h4>
        <h1 class="heroLoc">
            IN SOUTH BARRIE AT MAPLEVIEW E. & 20TH SIDEROAD
        </h1>
    </div>
    <div @click="scrollToIntro" class="bounce p-3">
      <b-img src="/img/downArrow.png" width="50" />
    </div>
    <h5
      style="color: #f9ae43; color: #f9ae43; font-size: 24px; font-weight: 400"
      class="pt-3 pt-sm-4 mb-4"
    >
      Live where you play &amp; re-discover the things you value most.
    </h5>
  </div>
</template>

<script>
const scrollToIntro = () => {
  const el = document.querySelector('#introTextNewSection')

  if (el) {
    el.scrollIntoView({
      behavior: 'smooth'
    })
  }
}
</script>

<style lang="scss">
#heroSec {
  background-image: url("/img/hero-image.png");
  background-repeat: no-repeat;
  background-size: contain;
  height: 132vh;

  .logoWrapper {
    padding: 50px;
  }

  .logo {
    width: 350px;
    height: auto;
  }

  .heroWrapper {
    display: flex;
    flex-direction: column;
    margin-top: 59vh;
  }

  .heroDate {
    font-size: 46px;
    font-weight: 700;
    margin-bottom: 0;
  }
  .heroRelease {
    font-size: 72px;
    font-weight: 400;
    margin-bottom: 0;
  }

  .heroBox {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .heroText {
    font-size: 44px;
    margin-bottom: 0;
  }

  .heroPrice {
    font-size: 130px;
    font-weight: 700;
    margin-bottom: 0;
  }

  .heroLoc {
    font-size: 28px;
    font-weight: 300;
  }
  .introTextNewSection {
    font-weight: normal;
    width: 100%;
    color: #f9ae43;
    position: absolute;
    bottom: 15px;
    left: 0px;
    padding-top: 50px;
    @media screen and (max-width: 768px) {
      font-size: 18px;
    }
  }
  
}

@media screen and (max-width: 1920px) {
    
    #heroSec {
        height: 145vh;

    .logo {
        width: 300px;
    }

    .heroWrapper {
        margin-top: 49vh;
    }
    }
}

@media screen and (max-width: 1440px) {
#heroSec {
    height: 105vh;
    .logo {
        width: 290px;
    }

    .heroWrapper {
        margin-top: 23vh;
    }
}
}

@media screen and (max-width: 1024px) {
  #heroSec {
    height: 91vh;

    .logo {
      width: 195px;
    }

    .heroWrapper {
      margin-top: 15vh;
    }
  }
}

@media screen and (max-width: 768px) {
  #heroSec {
    height: 68vh;

    .logoWrapper {
        padding: 25px;
    }

    .logo {
      width: 130px;
    }

    .heroWrapper {
      margin-top: 15vh;
    }

    .heroDate, .heroText {
        font-size: 35px;
    }

    .heroRelease {
        font-size: 45px;
    }

    .heroPrice {
        font-size: 75px;
    }

    .heroLoc {
        font-size: 21px;
    }
  }
}

.bounce {
  -moz-animation: bounce 3s infinite;
  -webkit-animation: bounce 3s infinite;
  animation: bounce 3s infinite;
}

@-moz-keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    -moz-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -moz-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -moz-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}

@-webkit-keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -webkit-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -webkit-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -moz-transform: translateY(-30px);
    -ms-transform: translateY(-30px);
    -webkit-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -moz-transform: translateY(-15px);
    -ms-transform: translateY(-15px);
    -webkit-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}

@media screen and (max-height: 568px) {
  .introTextNewSection {
    position: inherit;
    padding-top: 30px;
  }
  .bounce {
    display: none;
  }
}

@media screen and (max-width: 430px) {
  #heroSec {
    background-image: url("/img/hero-imageM.jpg");
    height: 100vh;

    .logoWrapper {
        padding-top: 5rem;
    }

    .logo {
      width: 150px;
    }

    .heroWrapper {
      margin-top: 34vh;
    }

    .heroDate, .heroText {
        font-size: 30px;
    }

    .heroRelease {
        font-size: 45px;
    }

    .heroPrice {
        font-size: 65px;
    }

    .heroLoc {
        font-size: 16px;
    }
  }
}
</style>
